export const settingsContainer = {
  width: '100%',
  padding: '16px 20px 20px 0',

  '@media (max-width: 1024px)': {
    padding: '20px 16px',
  },
};

export const topTitle = {
  background: 'var(--white)',
  borderRadius: '20px',
  padding: '23px 40px',
  boxShadow: '0px 0px 20px 0px #0000000D',
};

export const generalContainer = {
  display: 'grid',
  gridTemplateAreas: `'contact contact' 'language time' 'date thousands' 'details details'`,
  gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr);',
  gap: '16px',
  marginTop: '20px',

  '@media (max-width: 768px)': {
    display: 'flex',
    flexDirection: 'column',
  },
};

export const formContainer = {
  position: 'relative',
  boxShadow: '0px 0px 20px 0px #0000000D',
  margin: '0',
  padding: '16px',
  width: '100%',

  '@media (max-width: 768px)': {
    padding: '16px',
  },
};

export const accoutnDetailsContainer = {
  ...formContainer,
  padding: '16px',
  marginBottom: '20px',
};

export const inputsContainer = {
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: '12px 24px',
  marginTop: '16px',
  marginBottom: '20px',

  '@media (max-width: 768px)': {
    gridTemplateColumns: '1fr',
  },
};

export const updateBtn = {
  position: 'absolute',
  right: '16px',
  bottom: '16px',
  fontWeight: '500',
  fontSize: '18px',
  padding: '4px 20px',
  textTransform: 'capitalize',
  marginLeft: 'auto',
  borderRadius: '20px',
  width: 'fit-content',
  background: 'var(--primary)',
  color: 'var(--white)',
  cursor: 'pointer',

  '&.static': {
    display: 'block',
    position: 'static',
  },

  '&:disabled': {
    opacity: 0.5,
  },

  '&.subscribe': {
    border: '1px solid var(--primary)',
    background: 'var(--white)',
    color: 'var(--primary)',
  },

  '&.delete': {
    background: 'var(--darkRed)',
    color: 'var(--white)',
  },

  '&.loading': {
    minWidth: '100px',
    background: 'var(--grey500)',
  },

  '@media (max-width: 768px)': {
    position: 'static',
    display: 'block',
    margin: '0 auto',
  },
};

export const updatedText = {
  display: 'flex',
  justifyContent: 'flex-end',
  gap: '5px',
  marginTop: '4px',

  '@media (max-width: 768px)': {
    justifyContent: 'center',
  },
};

export const selectContainer = {
  marginTop: '16px',
  marginBottom: '20px',
};

export const radioContainer = {
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  marginTop: '16px',
  marginBottom: '10px',
};

export const radioControlLabel = {
  margin: '0 0 10px',

  '.MuiRadio-root': {
    color: 'var(--primary)',
    padding: '0',
    marginRight: '8px',

    '&.Mui-checked': {
      color: 'var(--primary)',
    },
  },

  '.MuiTypography-root': {
    fontWeight: '400',
    fontSize: '15px',
  },
};

export const detailsBox = {
  display: 'grid',
  gridTemplateColumns: '1fr',
  gap: '10px',

  '@media (max-width: 768px)': {
    gridTemplateColumns: '1fr',
  },
};

export const detailsItem = {
  position: 'relative',
  marginTop: '16px',
  marginBottom: '36px',
  height: '100%',

  '@media (max-width: 768px)': {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    marginBottom: '0',
  },
};

export const unSubscribeText = {
  display: 'block',
};

export const billingFields = {
  display: 'grid',
  gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr);',
  gap: '16px',

  '@media (max-width: 768px)': {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    marginBottom: '0',
  },
};
